export var LayoutCardVariantType;
(function (LayoutCardVariantType) {
    LayoutCardVariantType["MAIN_CONTENT_10_COLUMNS"] = "MAIN_CONTENT_10_COLUMNS";
    LayoutCardVariantType["MAIN_CONTENT_8_COLUMNS"] = "MAIN_CONTENT_8_COLUMNS";
    LayoutCardVariantType["MAIN_CONTENT_6_COLUMNS"] = "MAIN_CONTENT_6_COLUMNS";
    LayoutCardVariantType["MAIN_CONTENT_4_COLUMNS"] = "MAIN_CONTENT_4_COLUMNS";
})(LayoutCardVariantType || (LayoutCardVariantType = {}));
//# sourceMappingURL=layoutCardVariantType.js.map